import { DashboardLayout } from "../../components/dashboard-layout";
import { ThemeProvider, createTheme } from "@mui/material/styles";
import { theme } from "../../theme"; 
import { 
    Box, Button, Container, Table, TableBody, TableCell, TableHead, TableRow, 
    Card, CardContent, Typography, Stack, Chip, TableContainer, 
    CircularProgress, Grid, TextField, MenuItem, InputAdornment, Tooltip,
    Dialog, DialogTitle, DialogContent, DialogActions, IconButton,
    TablePagination 
} from "@mui/material";
import { 
    AccountBalanceWalletOutlined, DownloadOutlined, FormatListBulletedOutlined,
    SyncOutlined, SendOutlined, AccountBalanceOutlined, PersonOutlineOutlined,
    NumbersOutlined, PaymentsOutlined, LockOutlined, CloseOutlined, TimerOutlined,
    Telegram 
} from "@mui/icons-material";
import axios from "axios";
import swal from "sweetalert";
import { useEffect, useState } from "react";
import moment from "moment";
import { useForm } from "react-hook-form";

// ==========================================
// CẤU HÌNH DANH SÁCH NGƯỜI DUYỆT TELEGRAM
// ==========================================
const TELEGRAM_OPTIONS = [
    { id: "1340977274", name: "Admin 1" },
    { id: "6893557029", name: "Admin 2" }
];

// ==========================================
// THEME HIỆN ĐẠI (FINTECH STYLE)
// ==========================================
const modernTheme = createTheme({
    palette: {
        background: { default: "#F4F7FE", paper: "#FFFFFF" }, 
        text: { primary: "#1E293B", secondary: "#64748B" }, 
        primary: { main: "#2563EB", light: "#EFF6FF" },
        success: { main: "#10B981", light: "#ECFDF5" },
        danger: { main: "#EF4444", light: "#FEF2F2" },
        warning: { main: "#F59E0B", light: "#FFFBEB" },
    },
    typography: { fontFamily: "'Plus Jakarta Sans', 'Inter', sans-serif" },
    components: {
        MuiCard: { 
            styleOverrides: { 
                root: { borderRadius: "16px", boxShadow: "0px 10px 25px rgba(0, 0, 0, 0.04)", border: "none", overflow: "hidden" } 
            } 
        },
        MuiTableCell: { 
            styleOverrides: { 
                root: { borderBottom: "1px solid #F1F5F9 !important", padding: "16px", color: "#334155", fontSize: "0.875rem", fontFamily: "'Plus Jakarta Sans', sans-serif !important" },
                head: { backgroundColor: "#F8FAFC !important", color: "#64748B !important", fontWeight: "800 !important", textTransform: "uppercase", letterSpacing: "0.5px" }
            } 
        },
        MuiButton: { 
            styleOverrides: { root: { fontFamily: "'Plus Jakarta Sans', sans-serif", textTransform: 'none', borderRadius: '12px', fontWeight: 700 } } 
        }
    }
});

// ==========================================
// DANH SÁCH ĐẦY ĐỦ CÁC NGÂN HÀNG HỆ THỐNG
// ==========================================
const BANK_OPTIONS = [
    { code: 8001, name: "TPBank" },
    { code: 8002, name: "Techcombank" },
    { code: 8003, name: "VIB" },
    { code: 8004, name: "VPBank" },
    { code: 8005, name: "Vietcombank" },
    { code: 8006, name: "VietinBank" },
    { code: 8007, name: "MBBank" },
    { code: 8008, name: "ABBANK" },
    { code: 8009, name: "ACB" },
    { code: 8010, name: "BIDV" },
    { code: 8011, name: "OCB" },
    { code: 8012, name: "MSB" },
    { code: 8013, name: "SHB" },
    { code: 8014, name: "Agribank" },
    { code: 8015, name: "Sacombank" },
    { code: 8016, name: "HDBank" },
    { code: 8017, name: "BVBank" },
    { code: 8018, name: "SCB" },
    { code: 8019, name: "Eximbank" },
    { code: 8020, name: "CAKE" },
    { code: 8021, name: "Ubank" },
    { code: 8022, name: "Timo" },
    { code: 8023, name: "ViettelMoney" },
    { code: 8024, name: "VNPTMoney" },
    { code: 8025, name: "SaigonBank" },
    { code: 8026, name: "BacABank" },
    { code: 8027, name: "PVcomBank" },
    { code: 8028, name: "Oceanbank" },
    { code: 8029, name: "NCB" },
    { code: 8030, name: "ShinhanBank" },
    { code: 8031, name: "VietABank" },
    { code: 8032, name: "NamABank" },
    { code: 8033, name: "PGBank" },
    { code: 8034, name: "VietBank" },
    { code: 8035, name: "BaoVietBank" },
    { code: 8036, name: "SeABank" },
    { code: 8037, name: "COOPBANK" },
    { code: 8038, name: "LPBank" },
    { code: 8039, name: "KienLongBank" },
    { code: 8040, name: "KBank" },
    { code: 8041, name: "VRB" },
    { code: 8042, name: "DBSBank" },
    { code: 8043, name: "Woori" },
    { code: 8044, name: "KookminHN" },
    { code: 8045, name: "KookminHCM" },
    { code: 8046, name: "CBBank" },
    { code: 8047, name: "Nonghyup" },
    { code: 8048, name: "CIMB" },
    { code: 8049, name: "DongABank" },
    { code: 8050, name: "GPBank" },
    { code: 8051, name: "HongLeong" },
    { code: 8052, name: "UnitedOverseas" },
    { code: 8053, name: "HSBC" },
    { code: 8054, name: "IBKHN" },
    { code: 8055, name: "PublicBank" },
    { code: 8056, name: "IBKHCM" },
    { code: 8057, name: "IndovinaBank" },
    { code: 8058, name: "StandardChartered" },
    { code: 8059, name: "VBSP" },
    { code: 8060, name: "VDB" },
    { code: 8062, name: "ANZ" },
    { code: 8068, name: "CITIBANK" },
    { code: 8069, name: "KEBHANAHCM" },
    { code: 8070, name: "KEBHANAHN" },
    { code: 8071, name: "MAFC" },
    { code: 8072, name: "VikkiBank" },
    { code: 8074, name: "VietCapitalBank" },
    { code: 8075, name: "MBV" },
    { code: 8076, name: "LioBank" }
];

const getVietQRShortName = (bankName) => {
    if (!bankName) return "";
    const nameStr = bankName.toUpperCase().trim();
    
    if (nameStr.includes("VIETCOMBANK")) return "VCB";
    if (nameStr.includes("TECHCOMBANK")) return "TCB";
    if (nameStr.includes("VIETINBANK")) return "ICB";
    if (nameStr.includes("VPBANK")) return "VPB";
    if (nameStr.includes("KIENLONGBANK")) return "KLB";
    if (nameStr.includes("TPBANK")) return "TPB";
    if (nameStr.includes("MBBANK") || nameStr === "MB BANK" || nameStr === "MB") return "MB";
    if (nameStr.includes("AGRIBANK")) return "VBA";
    if (nameStr.includes("SACOMBANK")) return "STB";
    if (nameStr.includes("SEABANK")) return "SEAB";
    
    if (nameStr.includes("BIDV")) return "BIDV";
    if (nameStr.includes("OCB")) return "OCB";
    if (nameStr.includes("ACB")) return "ACB";
    if (nameStr.includes("HDBANK")) return "HDB";
    if (nameStr.includes("VIETCAPITALBANK")) return "VCCB";
    if (nameStr.includes("SCB")) return "SCB";
    if (nameStr.includes("VIB")) return "VIB";
    if (nameStr.includes("SHINHANBANK")) return "SHBVN"; 
    if (nameStr.includes("SHB") && !nameStr.includes("SHINHAN")) return "SHB"; 
    if (nameStr.includes("EXIMBANK")) return "EIB";
    if (nameStr.includes("MSB")) return "MSB";
    if (nameStr.includes("CAKE")) return "CAKE";
    if (nameStr.includes("UBANK")) return "UBANK"; 
    if (nameStr.includes("VIETTELMONEY")) return "VIETTELMONEY";
    if (nameStr.includes("TIMO")) return "TIMO";
    if (nameStr.includes("VNPTMONEY")) return "VNPTMONEY";
    if (nameStr.includes("SAIGONBANK")) return "SGICB";
    if (nameStr.includes("BACABANK")) return "BAB";
    if (nameStr.includes("MOMO")) return "momo";
    if (nameStr.includes("PVCOMBANK PAY")) return "PVCB";
    if (nameStr.includes("PVCOMBANK")) return "PVCB";
    if (nameStr.includes("MBV")) return "MBV";
    if (nameStr.includes("NCB")) return "NCB";
    if (nameStr.includes("ABBANK")) return "ABB";
    if (nameStr.includes("VIETABANK")) return "VAB";
    if (nameStr.includes("NAMABANK")) return "NAB";
    if (nameStr.includes("PGBANK")) return "PGB";
    if (nameStr.includes("VIETBANK")) return "VIETBANK";
    if (nameStr.includes("BAOVIETBANK")) return "BVB";
    if (nameStr.includes("COOPBANK")) return "COOPBANK";
    if (nameStr.includes("LPBANK")) return "LPB";
    if (nameStr.includes("KBANK")) return "KBANK";
    if (nameStr.includes("MAFC")) return "MAFC";
    if (nameStr.includes("HONGLEONG")) return "HLBVN";
    if (nameStr.includes("KEBHANAHN")) return "KEBHANAHN";
    if (nameStr.includes("KEBHANAHCM")) return "KEBHANAHCM";
    if (nameStr.includes("CITIBANK")) return "CITIBANK";
    if (nameStr.includes("CBBANK")) return "CBB";
    if (nameStr.includes("CIMB")) return "CIMB";
    if (nameStr.includes("DBSBANK")) return "DBS";
    if (nameStr.includes("VIKKI")) return "Vikki";
    if (nameStr.includes("VBSP")) return "VBSP";
    if (nameStr.includes("GPBANK")) return "GPB";
    if (nameStr.includes("KOOKMINHCM")) return "KBHCM";
    if (nameStr.includes("KOOKMINHN")) return "KBHN";
    if (nameStr.includes("WOORI")) return "WVN";
    if (nameStr.includes("VRB")) return "VRB";
    if (nameStr.includes("HSBC")) return "HSBC";
    if (nameStr.includes("IBKHN")) return "IBK";
    if (nameStr.includes("IBKHCM")) return "IBK";
    if (nameStr.includes("INDOVINABANK")) return "IVB";
    if (nameStr.includes("UNITEDOVERSEAS")) return "UOB";
    if (nameStr.includes("NONGHYUP")) return "NHB";
    if (nameStr.includes("STANDARDCHARTERED")) return "SCVN";
    if (nameStr.includes("PUBLICBANK")) return "PBVN";

    return nameStr;
};


axios.interceptors.request.use(
    (config) => {
        const token = localStorage.getItem("user");
        if (token) config.headers["Authorization"] = `Bearer ${token}`;
        return config;
    },
    (error) => Promise.reject(error)
);

function WithdrawAdmin() {
    const [load, setLoad] = useState(true);
    const [profile, setProfile] = useState(JSON.parse(localStorage.getItem("profile")));
    const [apiBalance, setApiBalance] = useState(0);
    const [historyList, setHistoryList] = useState([]);

    const [openOtpModal, setOpenOtpModal] = useState(false);
    const [otpCode, setOtpCode] = useState("");
    const [tempWithdrawData, setTempWithdrawData] = useState(null);
    const [timeLeft, setTimeLeft] = useState(300); 

    const [page, setPage] = useState(0);
    const rowsPerPage = 15;

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const { register, handleSubmit, reset, watch } = useForm();
    const selectedBankCode = watch("bankCode", "");
    const selectedTelegram = watch("telegram_chat_id", ""); 

    useEffect(() => {
        let timerId;
        if (openOtpModal && timeLeft > 0) {
            timerId = setInterval(() => setTimeLeft((prev) => prev - 1), 1000);
        } else if (timeLeft <= 0) {
            clearInterval(timerId);
        }
        return () => clearInterval(timerId);
    }, [openOtpModal, timeLeft]);

    const formatTime = (seconds) => {
        const m = Math.floor(seconds / 60);
        const s = seconds % 60;
        return `${m.toString().padStart(2, '0')}:${s.toString().padStart(2, '0')}`;
    };

    const fetchData = async () => {
        setLoad(true);
        try {
            const resBalance = await axios.get(`${process.env.REACT_APP_API_URL}/bank/balance`);
            if (resBalance.data && resBalance.data.success) {
                setApiBalance(resBalance.data.data.availableBalance || resBalance.data.data.balance || 0);
            }

            const resHistory = await axios.get(`${process.env.REACT_APP_API_URL}/payment/paymentus`);
            if (resHistory.data && resHistory.data.data) {
                const withdrawData = resHistory.data.data
                    .filter(p => p.type_payment === "CHUYỂN KHOẢN" || p.type_payment === "RÚT")
                    .sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt)); 
                setHistoryList(withdrawData);
                setPage(0);
            }
        } catch (error) {
            console.error("Lỗi lấy dữ liệu:", error);
        } finally {
            setLoad(false);
        }
    };

    useEffect(() => { fetchData(); }, []);

    const onSubmitWithdraw = async (data) => {
        const amount = Number(data.amount);
        if (amount < 100000) return swal("Lỗi", "Số tiền rút tối thiểu là 100.000 VNĐ", "error");

        const selectedAdminName = TELEGRAM_OPTIONS.find(t => t.id === data.telegram_chat_id)?.name || "Người duyệt";

        swal({
            title: "Yêu cầu rút tiền?",
            text: `Hệ thống sẽ gửi mã OTP đến Telegram của: ${selectedAdminName} để duyệt khoản rút ${amount.toLocaleString('vi-VN')} VNĐ.`,
            icon: "warning",
            buttons: ["Hủy", "Lấy mã OTP"],
            dangerMode: true,
        }).then(async (willConfirm) => {
            if (willConfirm) {
                setLoad(true);
                try {
                    const payload = {
                        bankCode: data.bankCode,
                        bank_id: BANK_OPTIONS.find(b => b.code == data.bankCode)?.name || "",
                        bank_no: data.bank_no,
                        bank_account: data.bank_account,
                        amount: amount,
                        telegram_chat_id: data.telegram_chat_id 
                    };

                    const res = await axios.post(`${process.env.REACT_APP_API_URL}/bank/requestWithdrawOTP`, payload);
                    
                    if (res.data.success) {
                        setTempWithdrawData(payload); 
                        setTimeLeft(300); 
                        setOpenOtpModal(true);        
                    }
                } catch (error) {
                    swal("Thất bại", error.response?.data?.message || "Lỗi tạo lệnh xuất khoản", "error");
                } finally {
                    setLoad(false);
                }
            }
        });
    };

    const handleConfirmOTP = async () => {
        if (!otpCode || otpCode.trim() === "") return swal("Lỗi", "Vui lòng nhập mã OTP!", "error");
        setLoad(true);
        try {
            const finalPayload = { ...tempWithdrawData, otp: otpCode.trim() };
            const res = await axios.post(`${process.env.REACT_APP_API_URL}/bank/bankout`, finalPayload);
            if (res.data.success) {
                swal("Thành công", "Đã gửi lệnh xuất khoản tự động!", "success");
                handleCloseOtpModal();
                reset(); 
                fetchData();
            }
        } catch (error) {
            swal("Thất bại", error.response?.data?.message || "Mã OTP không chính xác hoặc đã hết hạn", "error");
        } finally {
            setLoad(false);
        }
    };

    const handleCloseOtpModal = () => {
        setOpenOtpModal(false);
        setOtpCode("");
        setTempWithdrawData(null);
        setTimeLeft(300);
    };

    const handleExportJSON = () => {
        if (historyList.length === 0) return swal("Thông báo", "Không có dữ liệu để xuất!", "warning");
        const dataStr = JSON.stringify(historyList, null, 2);
        const blob = new Blob([dataStr], { type: "application/json" });
        const url = URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.download = `V8Pay_LichSuRutTien_${moment().format("DDMMYYYY_HHmm")}.json`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(url);
        swal("Đã lưu JSON", "File đã tải xuống thiết bị của bạn", "success");
    };

    const textFieldSx = {
        '& .MuiInputBase-root': {
            backgroundColor: '#F8FAFC', borderRadius: '12px', transition: 'all 0.2s ease', height: '56px', boxSizing: 'border-box'
        },
        '& .MuiOutlinedInput-notchedOutline': { borderColor: '#E2E8F0', borderWidth: '1px' },
        '&:hover .MuiOutlinedInput-notchedOutline': { borderColor: '#94A3B8' },
        '& .Mui-focused': { backgroundColor: '#FFFFFF', boxShadow: '0 0 0 4px rgba(37, 99, 235, 0.1)' },
        '& .Mui-focused .MuiOutlinedInput-notchedOutline': { borderColor: '#2563EB !important', borderWidth: '2px' },
        '& .MuiInputBase-input': { fontSize: '1.05rem', color: '#1E293B', fontWeight: 700, padding: '0 14px', height: '100%', boxSizing: 'border-box', display: 'flex', alignItems: 'center' },
        '& .MuiSelect-select': { display: 'flex', alignItems: 'center', padding: '0 14px !important' }
    };

    return (
        <ThemeProvider theme={theme}>
            <DashboardLayout>
                    <ThemeProvider theme={modernTheme}>
                        <Box component="main" sx={{ flexGrow: 1, py: 4, backgroundColor: 'background.default', minHeight: 'calc(100vh - 70px)', position: 'relative' }}>
                            {load && (
                                <Box sx={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, backgroundColor: 'rgba(255,255,255,0.7)', zIndex: 9999, display: 'flex', alignItems: 'center', justifyContent: 'center', backdropFilter: 'blur(4px)' }}>
                                    <CircularProgress size={50} sx={{ color: '#2563EB' }} />
                                </Box>
                            )}

                            <Container maxWidth="xl">
                                <Box mb={4} display="flex" alignItems="center" justifyContent="space-between">
                                    <Box display="flex" alignItems="center" gap={2}>
                                        <Box sx={{ p: 1.5, backgroundColor: '#EFF6FF', borderRadius: '12px' }}>
                                            <AccountBalanceWalletOutlined sx={{ fontSize: '2rem', color: '#2563EB' }} />
                                        </Box>
                                        <Box>
                                            <Typography variant="h4" fontWeight="800" color="text.primary">Quản lý Xuất Khoản</Typography>
                                            <Typography variant="body2" color="text.secondary">Thao tác tạo lệnh và kiểm soát dòng tiền tự động</Typography>
                                        </Box>
                                    </Box>
                                    <Button variant="outlined" color="primary" startIcon={<SyncOutlined />} onClick={fetchData} sx={{ px: 3, py: 1.2 }}>Làm Mới</Button>
                                </Box>

                                <Grid container spacing={4} mb={4}>
                                    <Grid item xs={12} md={4}>
                                        <Card sx={{ background: 'linear-gradient(135deg, #0F172A 0%, #1E3A8A 100%)', color: '#FFF', position: 'relative', height: '100%', minHeight: '260px' }}>
                                            <Box sx={{ position: 'absolute', top: -30, right: -30, width: 150, height: 150, borderRadius: '50%', background: 'rgba(255,255,255,0.05)' }} />
                                            <Box sx={{ position: 'absolute', bottom: -50, right: 20, width: 200, height: 200, borderRadius: '50%', background: 'rgba(255,255,255,0.03)' }} />
                                            <CardContent sx={{ p: 4, display: 'flex', flexDirection: 'column', justifyContent: 'center', height: '100%', position: 'relative', zIndex: 2 }}>
                                                <Typography variant="overline" sx={{ opacity: 0.7, letterSpacing: '1px', display: 'flex', alignItems: 'center', gap: 1 }}>
                                                    <AccountBalanceOutlined fontSize="small" /> SỐ DƯ CỔNG V8PAY (API)
                                                </Typography>
                                                <Typography variant="h3" fontWeight="800" sx={{ mt: 1.5, mb: 1 }}>
                                                    {apiBalance.toLocaleString('vi-VN')} <span style={{ fontSize: '1.2rem', fontWeight: 500, opacity: 0.8 }}>VNĐ</span>
                                                </Typography>
                                                <Stack direction="row" alignItems="center" spacing={1} sx={{ mt: 'auto', pt: 3 }}>
                                                    <Chip label="API Connected" size="small" sx={{ backgroundColor: 'rgba(16, 185, 129, 0.2)', color: '#34D399', fontWeight: 700 }} />
                                                    <Typography variant="caption" sx={{ opacity: 0.8 }}>Real-time update</Typography>
                                                </Stack>
                                            </CardContent>
                                        </Card>
                                    </Grid>

                                    <Grid item xs={12} md={8}>
                                        <Card sx={{ height: '100%' }}>
                                            <CardContent sx={{ p: 4 }}>
                                                <Typography variant="h6" fontWeight="800" color="#2563EB" mb={4} sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
                                                    <Box sx={{ p: 1, backgroundColor: '#EFF6FF', borderRadius: '8px' }}><SendOutlined color="primary" fontSize="small" /></Box>
                                                    TẠO LỆNH XUẤT KHOẢN MỚI
                                                </Typography>

                                                <form onSubmit={handleSubmit(onSubmitWithdraw)}>
                                                    <Grid container spacing={4}>
                                                        <Grid item xs={12} sm={6}>
                                                            <Typography variant="subtitle2" fontWeight="800" color="text.secondary" mb={1.5} display="block">CHỌN NGÂN HÀNG NHẬN</Typography>
                                                            <TextField 
                                                                select fullWidth {...register("bankCode", { required: true })} value={selectedBankCode} sx={textFieldSx} displayEmpty
                                                                SelectProps={{
                                                                    renderValue: (value) => {
                                                                        if (!value) return <Typography color="#94A3B8" fontWeight={600}>-- Chọn Ngân Hàng --</Typography>;
                                                                        const selectedBank = BANK_OPTIONS.find(b => b.code === value);
                                                                        const shortName = getVietQRShortName(selectedBank?.name);
                                                                        return (
                                                                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
                                                                                <img src={`https://api.vietqr.io/img/${shortName}.png`} alt={selectedBank?.name} style={{ height: '24px', width: 'auto', objectFit: 'contain' }} onError={(e) => { e.target.src = "https://cdn-icons-png.flaticon.com/512/2830/2830284.png" }} />
                                                                                <Typography fontWeight="700" color="#1E293B">{selectedBank?.name}</Typography>
                                                                            </Box>
                                                                        );
                                                                    }
                                                                }}
                                                            >
                                                                <MenuItem value="" disabled>-- Chọn Ngân Hàng --</MenuItem>
                                                                {BANK_OPTIONS.map((bank) => {
                                                                    const shortName = getVietQRShortName(bank.name);
                                                                    return (
                                                                        <MenuItem key={bank.code} value={bank.code} sx={{ py: 1.5, display: 'flex', gap: 2, borderBottom: '1px solid #F1F5F9' }}>
                                                                            <img src={`https://api.vietqr.io/img/${shortName}.png`} alt={bank.name} style={{ height: '28px', width: '60px', objectFit: 'contain' }} onError={(e) => { e.target.src = "https://cdn-icons-png.flaticon.com/512/2830/2830284.png" }} />
                                                                            <Typography fontWeight="700" color="#1E293B">{bank.name}</Typography>
                                                                        </MenuItem>
                                                                    );
                                                                })}
                                                            </TextField>
                                                        </Grid>

                                                        <Grid item xs={12} sm={6}>
                                                            <Typography variant="subtitle2" fontWeight="800" color="text.secondary" mb={1.5} display="block">SỐ TÀI KHOẢN</Typography>
                                                            <TextField fullWidth placeholder="Nhập STK..." {...register("bank_no", { required: true })} sx={textFieldSx}
                                                                InputProps={{ startAdornment: <InputAdornment position="start"><NumbersOutlined sx={{ color: '#2563EB' }} /></InputAdornment> }}
                                                            />
                                                        </Grid>

                                                        <Grid item xs={12} sm={6}>
                                                            <Typography variant="subtitle2" fontWeight="800" color="text.secondary" mb={1.5} display="block">TÊN CHỦ TÀI KHOẢN</Typography>
                                                            <TextField fullWidth placeholder="VD: NGUYEN VAN A" {...register("bank_account", { required: true })} sx={textFieldSx}
                                                                InputProps={{ startAdornment: <InputAdornment position="start"><PersonOutlineOutlined sx={{ color: '#2563EB' }} /></InputAdornment> }}
                                                            />
                                                        </Grid>

                                                        <Grid item xs={12} sm={6}>
                                                            <Typography variant="subtitle2" fontWeight="800" color="text.secondary" mb={1.5} display="block">SỐ TIỀN CẦN RÚT (VNĐ)</Typography>
                                                            <TextField fullWidth type="number" placeholder="Tối thiểu 100.000" {...register("amount", { required: true, min: 100000 })} sx={textFieldSx}
                                                                InputProps={{ startAdornment: <InputAdornment position="start"><PaymentsOutlined sx={{ color: '#10B981' }} /></InputAdornment> }}
                                                            />
                                                        </Grid>

                                                        <Grid item xs={12}>
                                                            <Typography variant="subtitle2" fontWeight="800" color="text.secondary" mb={1.5} display="block">CHỌN NGƯỜI DUYỆT OTP (TELEGRAM)</Typography>
                                                            <TextField 
                                                                select fullWidth {...register("telegram_chat_id", { required: true })} value={selectedTelegram} sx={textFieldSx} displayEmpty
                                                                SelectProps={{
                                                                    renderValue: (value) => {
                                                                        if (!value) return <Typography color="#94A3B8" fontWeight={600}>-- Chọn người nhận OTP --</Typography>;
                                                                        const selectedOpt = TELEGRAM_OPTIONS.find(t => t.id === value);
                                                                        return (
                                                                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
                                                                                <Telegram sx={{ color: '#0088cc' }} />
                                                                                <Typography fontWeight="700" color="#1E293B">{selectedOpt?.name}</Typography>
                                                                            </Box>
                                                                        );
                                                                    }
                                                                }}
                                                            >
                                                                <MenuItem value="" disabled>-- Chọn người nhận OTP --</MenuItem>
                                                                {TELEGRAM_OPTIONS.map((opt) => (
                                                                    <MenuItem key={opt.id} value={opt.id} sx={{ py: 1.5, borderBottom: '1px solid #F1F5F9' }}>
                                                                        <Telegram sx={{ color: '#0088cc', mr: 1.5 }} />
                                                                        <Typography fontWeight="700" color="#1E293B">{opt.name}</Typography>
                                                                    </MenuItem>
                                                                ))}
                                                            </TextField>
                                                        </Grid>

                                                        <Grid item xs={12} mt={1}>
                                                            <Button type="submit" variant="contained" color="primary" size="large" fullWidth 
                                                                sx={{ py: 2, height: '56px', fontSize: '1.1rem', letterSpacing: '0.5px', boxShadow: '0 8px 20px rgba(37, 99, 235, 0.25)', '&:hover': { boxShadow: '0 10px 25px rgba(37, 99, 235, 0.4)', transform: 'translateY(-2px)' }, transition: 'all 0.2s' }}
                                                            >
                                                                THỰC HIỆN XUẤT KHOẢN
                                                            </Button>
                                                        </Grid>
                                                    </Grid>
                                                </form>
                                            </CardContent>
                                        </Card>
                                    </Grid>
                                </Grid>

                                <Card>
                                    <Box sx={{ p: 3, display: 'flex', justifyContent: 'space-between', alignItems: 'center', backgroundColor: '#FFFFFF' }}>
                                        <Typography variant="h6" fontWeight="800" color="text.primary" sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
                                            <Box sx={{ p: 1, backgroundColor: '#F8FAFC', borderRadius: '8px' }}><FormatListBulletedOutlined sx={{ color: '#2563EB' }} fontSize="small" /></Box>
                                            DANH SÁCH LỆNH RÚT GẦN ĐÂY
                                        </Typography>
                                        <Tooltip title="Tải xuống toàn bộ dữ liệu dưới dạng JSON" arrow placement="top">
                                            <Button variant="outlined" color="success" startIcon={<DownloadOutlined />} onClick={handleExportJSON} sx={{ px: 3, py: 1, borderWidth: '2px', '&:hover': { borderWidth: '2px', backgroundColor: '#ECFDF5' } }}>
                                                XUẤT JSON
                                            </Button>
                                        </Tooltip>
                                    </Box>

                                    <TableContainer sx={{ overflowX: 'auto', maxHeight: '600px', backgroundColor: '#FFFFFF' }}>
                                        <Table stickyHeader sx={{ minWidth: 1460 }}>
                                            <TableHead>
                                                <TableRow>
                                                    <TableCell sx={{ pl: 4 }}>Mã Giao Dịch</TableCell>
                                                    <TableCell>Thời Gian</TableCell>
                                                    <TableCell>Tài Khoản Yêu Cầu</TableCell>
                                                    <TableCell>Thông Tin Nhận</TableCell>
                                                    <TableCell>Số Tiền Rút</TableCell>
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                {historyList && historyList.length > 0 ? (
                                                    historyList
                                                        .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                                        .map((item, index) => (
                                                        <TableRow key={item._id} hover sx={{ backgroundColor: index % 2 === 0 ? '#FFFFFF' : '#F8FAFC' }}>
                                                            <TableCell sx={{ pl: 4, fontWeight: "700", color: "#334155" }}>{item.transactionid || "N/A"}</TableCell>
                                                            <TableCell sx={{ color: "#64748B", fontWeight: 500 }}>{moment(item.createdAt).format("DD/MM/YYYY HH:mm")}</TableCell>
                                                            <TableCell sx={{ fontWeight: "700", color: "#2563EB" }}>{item.user?.username || "Admin"}</TableCell>
                                                            <TableCell sx={{ color: "#334155", fontWeight: 600 }}>{item.detail}</TableCell>
                                                            <TableCell sx={{ fontWeight: "800", color: "#EF4444", fontSize: "1rem" }}>{Number(item.money).toLocaleString('vi-VN')} ₫</TableCell>
                                                        </TableRow>
                                                    ))
                                                ) : (
                                                    <TableRow>
                                                        <TableCell colSpan={6} align="center" sx={{ py: 8, color: '#94A3B8', fontWeight: 600 }}>
                                                            <FormatListBulletedOutlined sx={{ fontSize: 40, opacity: 0.5, mb: 1, display: 'block', mx: 'auto' }} />
                                                            Chưa có dữ liệu lịch sử rút tiền
                                                        </TableCell>
                                                    </TableRow>
                                                )}
                                            </TableBody>
                                        </Table>
                                    </TableContainer>

                                    <TablePagination
                                        rowsPerPageOptions={[15]}
                                        component="div"
                                        count={historyList.length}
                                        rowsPerPage={rowsPerPage}
                                        page={page}
                                        onPageChange={handleChangePage}
                                        labelRowsPerPage="Số dòng mỗi trang:"
                                        labelDisplayedRows={({ from, to, count }) => `${from} - ${to} trong tổng ${count !== -1 ? count : `hơn ${to}`}`}
                                    />
                                </Card>

                                <Dialog open={openOtpModal} onClose={handleCloseOtpModal} PaperProps={{ sx: { borderRadius: '16px', padding: '8px', minWidth: '400px', boxShadow: '0 25px 50px -12px rgba(0, 0, 0, 0.25)' } }}>
                                    <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', pb: 1 }}>
                                        <Typography variant="h6" fontWeight="800" sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                            <LockOutlined color="primary" /> XÁC THỰC BẢO MẬT
                                        </Typography>
                                        <IconButton onClick={handleCloseOtpModal} size="small"><CloseOutlined /></IconButton>
                                    </DialogTitle>
                                    <DialogContent>
                                        <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
                                            <Typography variant="body2" color="text.secondary">Nhập mã OTP (6 số) từ Telegram:</Typography>
                                            <Chip icon={<TimerOutlined />} label={formatTime(timeLeft)} color={timeLeft < 60 ? "error" : "primary"} variant={timeLeft < 60 ? "filled" : "outlined"} size="small" sx={{ fontWeight: 'bold', fontSize: '1rem' }} />
                                        </Box>
                                        <TextField fullWidth autoFocus disabled={timeLeft <= 0} placeholder={timeLeft > 0 ? "Nhập mã OTP..." : "Mã OTP đã hết hạn"} value={otpCode} onChange={(e) => setOtpCode(e.target.value)} sx={textFieldSx} InputProps={{ startAdornment: <InputAdornment position="start"><LockOutlined sx={{ color: timeLeft <= 0 ? '#94A3B8' : '#2563EB' }} /></InputAdornment> }} inputProps={{ maxLength: 6, style: { letterSpacing: '4px', textAlign: 'center', fontSize: '1.2rem' } }} />
                                        {timeLeft <= 0 && <Typography color="error" variant="caption" sx={{ display: 'block', mt: 1, textAlign: 'center', fontWeight: 'bold' }}>Mã OTP đã hết hạn. Vui lòng đóng cửa sổ và tạo lại lệnh.</Typography>}
                                    </DialogContent>
                                    <DialogActions sx={{ px: 3, pb: 3 }}>
                                        <Button onClick={handleCloseOtpModal} color="inherit" sx={{ fontWeight: 600 }}>Đóng</Button>
                                        <Button onClick={handleConfirmOTP} variant="contained" color="primary" disabled={timeLeft <= 0} sx={{ px: 4, py: 1.5, borderRadius: '8px' }}>XÁC NHẬN RÚT</Button>
                                    </DialogActions>
                                </Dialog>

                            </Container>
                        </Box>
                    </ThemeProvider>
               
            </DashboardLayout>
        </ThemeProvider>
    );
}

export default WithdrawAdmin;